export class TimeSpan {
  public startDate: Date;
  public endDate: Date;

  constructor(startDate: Date, endDate: Date) {
    this.startDate = startDate;
    this.endDate = endDate;
  }

  public Contained(otherTs: TimeSpan) {
    var ret = false;

    var thisStartTime = this.startDate.getTime();
    var thisEndTime = this.endDate.getTime();

    var otherStartTime = otherTs.startDate.getTime();
    var otherEndTime = otherTs.endDate.getTime();

    if (thisStartTime >= otherStartTime && thisEndTime <= otherEndTime) {
      ret = true;
    }

    return ret;
  }

  public Contains(otherTs: TimeSpan) {
    var ret = false;

    var thisStartTime = this.startDate.getTime();
    var thisEndTime = this.endDate.getTime();

    var otherStartTime = otherTs.startDate.getTime();
    var otherEndTime = otherTs.endDate.getTime();

    if (thisStartTime <= otherStartTime && thisEndTime >= otherEndTime) {
      ret = true;
    }

    return ret;
  }

  public OverlapBeginning(otherTs: TimeSpan) {
    var ret = false;

    var thisStartTime = this.startDate.getTime();
    var thisEndTime = this.endDate.getTime();

    var otherStartTime = otherTs.startDate.getTime();

    if (thisStartTime <= otherStartTime && thisEndTime >= otherStartTime) {
      ret = true;
    }

    return ret;
  }

  public OverlapEnd(otherTs: TimeSpan) {

    var ret = false;

    var thisStartTime = this.startDate.getTime();
    var thisEndTime = this.endDate.getTime();

    var otherEndTime = otherTs.endDate.getTime();

    if (thisStartTime <= otherEndTime && thisEndTime >= otherEndTime) {
      ret = true;
    }

    return ret;
  }

  public Intersect(otherTs: TimeSpan) {

    var ret = false;

    if (this.OverlapBeginning(otherTs)) { //The other starts during our time span
      ret = true;
    }
    else if (this.OverlapEnd(otherTs)) { //The other ends during our time span
      ret = true;
    }
    else if (this.Contained(otherTs)) { //Our span occurs totally inside this other span
      ret = true;
    }
    else if (this.Contains(otherTs)) { //The other span occurs totally inside our span
      ret = true;
    }

    return ret;
  }
}
